<template>
<div>
    <div class="holidaysForm">

        <div class="errors">
            <p v-for="err in errors" :key="err">{{err}}</p>
        </div>

        <form v-on:keyup.enter="addHoliday" class="editForm shadow">
            <div>
                <label id="labelDate">Selection du jour : </label>
                <v-date-picker class="datepickerH"
                v-model="holidayDate" 
                :popover="{ placement: 'bottom', visibility: 'click' }" 
                :first-day-of-week="2"
                locale="fr-FR"/>
            </div>
            <div class="selectImputMidWith">
                <div id="checkboxInput">
                    <label for="checkbox"><input id="checkbox" type="checkbox" v-model="annual"> Récurrent</label>
                </div>
            </div>
            <div class="btn row btn-outline-success" v-on:click="addHoliday">Ajouter</div>
        </form>
    </div>

    <div class="load-icon" v-if="loading">
        <b-icon icon="gear-fill" animation="spin" font-scale="7"></b-icon>
    </div>
    <div class="holidaysList" v-else>
        <table>
            <thead>
                <th scope="col">Jours feriés enregistrés</th>
                <tbody class="projects">
                    <tr v-for="day in holidays" :key="day.id" class="lineHover">
                        <td>{{day.date}}</td>
                        <td v-if="day.annual">Récurrent</td>
                        <td v-else>Non Récurrent</td>
                        <td class="delete">
                            <b-icon v-on:click="deleteHoliday(day)" icon="x-circle-fill" />
                        </td>
                    </tr>
                </tbody>
            </thead>
        </table>
    </div>
</div>
</template>

<script>
    const axios = require('axios');

    export default {
        name: "Holidays",
        created: function() {
            this.userId = Number(localStorage.id);

            //Réccupération de tous les jours fériés 
            axios.get(this.$store.state.apiUrl + "holidays/getAll", {
                params: {
                login: localStorage.login,
                password: localStorage.pass
                }
            })
            .then(response =>{
                this.sort_data(response);
                this.loading = false;
            }).catch(e => {
                this.printError(e);
            });
        },
        data() {
            return {
                holidayDate: null,
                annual: false,
                holidays: [],
                errors: [],
                loading: true,
            };
        },
        methods: {
            sort_data: function(response){
                //Tri des données de jours fériés en base par ordre chronologique croissant
                
                var holidays_brut = response.data;

                // Tri des date dans le sens chronologique 
                holidays_brut.sort(function(a,b) {
                    var a_date = a['date'].split('/').reverse().join('');
                    var b_date = b['date'].split('/').reverse().join('');
                    return a_date > b_date ? 1 : a_date < b_date ? -1 : 0;
                });

                this.holidays = holidays_brut;
            },
            addHoliday: function(){

                this.errors = [];

                // réccupération de la valeur du champs date
                if(this.holidayDate){
                    var dateString = ("0"+this.holidayDate.getDate()).slice(-2) + "/" + ("0"+(this.holidayDate.getMonth()+1)).slice(-2) + "/" + this.holidayDate.getFullYear();
                }

                var tmpData = new FormData();
                tmpData.append('date',dateString);
                tmpData.append('annual',this.annual);
                this.loading = true;

                // Requete d'ajout de la date en base
                axios.post(this.$store.state.apiUrl + "holidays/new", tmpData, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                })
                .then(response_new =>{

                    if(response_new.status == 202){
                        this.errors = response_new.data;
                        this.loading = false;
                        return;
                    }

                    // Réccupération de la nouvelle liste de jours fériés après ajout de la nouvelle date
                    axios.get(this.$store.state.apiUrl + "holidays/getAll", {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => {
                        this.sort_data(response)
                        this.loading = false;
                        this.$toasted.show("Jour ajouté avec succès", {
                            position: 'bottom-center',
                            theme: 'outline'
                        }).goAway(3000);
                    })
                    .catch(e => {
                        this.printError(e);
                        this.loading = false;
                    });
                })
                .catch(e => {
                    this.printError(e);
                    this.loading = false;
                });

            },
            deleteHoliday: function(day){

                this.loading = true;

                //Requete de suppression du jour férié sélectionné
                axios.post(this.$store.state.apiUrl + "holidays/delete/" + day.id, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                })
                .then(() => {
                    // Réccupération de la nouvelle liste de jours fériés après suppression de la date sélectionnée
                    axios.get(this.$store.state.apiUrl + "holidays/getAll", {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => {
                        this.sort_data(response);
                        this.loading = false;

                        //Message de confirmation de suppression
                        this.$toasted.show("Jour supprimé avec succès", {
                            position: 'bottom-center',
                            theme: 'outline'
                        }).goAway(3000);
                    })
                    .catch(e => {
                        this.printError(e);
                        this.loading = false;
                    });
                })
                .catch(e => {
                    this.printError(e);
                });

            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur : " + e, {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            },
        }
    };
</script>

<style scoped>
    #checkboxInput { display:flex; justify-content: space-evenly }

    form input {
        border: 1px solid #ced4da;
        border-radius: .25rem;
        margin-bottom: 1.5em;
        padding: 4px;
    }

    .editForm{
        width: 60%;
        display: inline-table;
        padding: 15px;
    }

    .holidaysForm{
        text-align: center;
    }

    .datepickerH{
        width: 30%;
        display: inline-block;
        position: relative;
        margin-bottom: 3%;
    }

    #labelDate{
        margin-right: 10px;
    }

    .holidaysList{
        display: inline-table;
        margin-top: 3%;
        width: 100%;
    }

    table{
        display: inline-table;
        width: 30%;
    }

    th{
        display: block;
        margin-bottom: 10px;
    }

    tr{
        display: inline-table;
        width: 100%;
    }

    td{
        display: inline-table;
        width: 33%;
    }
    
    .errors{
		color: #dc3545;
	}

    .delete{
        cursor: pointer;
    }

    .lineHover:hover{
        background-color: #ced4da;
    }

    .load-icon{
        margin-top: 5%;
        color: #fec053;
    }

    @media screen and (max-width: 1050px){
        table{
            display: inline-table;
            width: 50%;
        }
    }
    

    @media screen and (max-width: 820px){
        table{
            display: inline-table;
            width: 60%;
        }
    }

    @media screen and (max-width: 535px){
        table{
            display: inline-table;
            width: 100%;
        }
    }
    

</style>